import { cn } from '@latitude/token-utils';
import * as ToastPrimitives from '@radix-ui/react-toast';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';

/**
 * Represents a Toast action component.
 *
 * @component
 * @example
 * ```tsx
 * <ToastAction onClick={handleClick} className="custom-class" />
 * ```
 */
export const ToastAction = ({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof ToastPrimitives.Action> & {
  ref?: Ref<ComponentRef<typeof ToastPrimitives.Action>>;
}) => (
  <ToastPrimitives.Action
    ref={ref}
    className={cn(['inline-flex', 'items-center', 'justify-center'], className)}
    {...props}
  />
);
ToastAction.displayName = ToastPrimitives.Action.displayName;
